//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Clipboard from 'clipboard';
export default {
  props: {
    zxmaster: {
      type: Boolean,
      default: false,
    },
    headSrc: {
      type: String,
      default: require('./_img/zxds_head.png'),
    },
    wx: {
      type: String,
      default: '2865880',
    },
  },
  data() {
    return {};
  },
  methods: {
    copy_wx() {
      const _this = this;
      var clipboard = new Clipboard('.wx-btn');
      clipboard.on('success', (e) => {
        _this.$Glb.PlMessage('复制成功', 800);
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', (e) => {
        // 不支持复制
        _this.$Glb.PlMessage('该浏览器不支持一键复制,请长按手动复制', 800);
        // 释放内存
        clipboard.destroy();
      });
    },
    Open_WeChat() {
      window.location.href = 'weixin://';
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Consulting_master.vue